<div class="b2c-auth-wrapper">
  <div class="lock-word animated fadeInDown">
    <span class="first-word">LOCKED</span>
    <span>SCREEN</span>
  </div>
  <div class="middle-box text-center lockscreen animated fadeInDown">
    <div>
      <div class="m-b-md">
        <img class="img-circle circle-border userPicture140-size" [src]="appConfig.statics.userDefaultUploadImage" alt="" />
      </div>
      <p class="lockScreen-Desc">Your user has been deleted or disabled</p>
      <shared-ui-buttons-button [text]="'Go to login'" [type]="buttonType.Primary" [size]="buttonSize.Small" (action)="logout()"></shared-ui-buttons-button>
    </div>
  </div>
</div>
